import axios from 'axios';

export function authHeader() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

const h = () => ({ headers: authHeader() });

export const inventoryApi = {
  properties: () => axios.get('/api/inventory/picker/properties', h()),
  locations: (propertyId) =>
    axios.get('/api/inventory/picker/locations', { ...h(), params: { propertyId } }),
  storageLocations: (propertyId) =>
    axios.get('/api/inventory/picker/storage-locations', { ...h(), params: { propertyId } }),
  types: (propertyId) =>
    axios.get('/api/inventory/picker/types', { ...h(), params: { propertyId } }),
  statuses: () => axios.get('/api/inventory/picker/statuses', h()),
  items: (params) => axios.get('/api/inventory/items', { ...h(), params }),
  createItem: (body) => axios.post('/api/inventory/items', body, h()),
  patchItem: (id, body) => axios.patch(`/api/inventory/items/${id}`, body, h()),
  splitItem: (id, body) => axios.post(`/api/inventory/items/${id}/split`, body, h()),
  adminTypes: (propertyId) =>
    axios.get('/api/inventory/admin/types', { ...h(), params: { propertyId } }),
  adminCreateType: (body) => axios.post('/api/inventory/admin/types', body, h()),
  adminUpdateType: (id, body) => axios.put(`/api/inventory/admin/types/${id}`, body, h()),
  adminDeleteType: (id) => axios.delete(`/api/inventory/admin/types/${id}`, h()),
  adminStatuses: () => axios.get('/api/inventory/admin/statuses', h()),
  adminCreateStatus: (body) => axios.post('/api/inventory/admin/statuses', body, h()),
  adminUpdateStatus: (id, body) => axios.put(`/api/inventory/admin/statuses/${id}`, body, h()),
  adminDeleteStatus: (id) => axios.delete(`/api/inventory/admin/statuses/${id}`, h()),
  adminStorageLocations: (propertyId) =>
    axios.get('/api/inventory/admin/storage-locations', { ...h(), params: { propertyId } }),
  adminCreateStorageLocation: (body) =>
    axios.post('/api/inventory/admin/storage-locations', body, h()),
  adminUpdateStorageLocation: (id, body) =>
    axios.put(`/api/inventory/admin/storage-locations/${id}`, body, h()),
  adminDeleteStorageLocation: (id) =>
    axios.delete(`/api/inventory/admin/storage-locations/${id}`, h()),
  adminImportItems: (rows) => axios.post('/api/inventory/admin/items/import', { rows }, h()),
};
